import { useState } from "react";
const apiURL = process.env.REACT_APP_API_URL;

export const useForm = (initialForm, validateForm) => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({});
  const [errorAPI, setErrorApi] = useState(false);

  // para modal
  const [showModal, setShowModal] = useState(false);  

  // cuando el elemento cambia su valor
  const handleChange = async (e) => {
    const { name, value } = e.target;
    setForm(await { ...form, [name]: value });
    setErrors(validateForm(form));
  };

  // cuando pasa al siguiente elemento del form
  const handleBlur = (e) => {
    handleChange(e);
    setErrors(validateForm(form));
  };

  //envio del form
  const handleSubmit = async (e) => {
    e.preventDefault();
    //verificamos que no existan errores en el form
    const err = validateForm(form);
    await setErrors(err);
    if (Object.keys(err).length === 0) {
      const p_sistema = e.target.sistema.value;
      const p_cuit = e.target.cuit.value.replaceAll("-", "");
      const p_anio = e.target.anio.value;
      const p_mes = e.target.mes.value;

      setLoading(true);
      setShowModal(false);
      

      try {
        const result = fetch(
          //`https://sircreb.comarb.gob.ar/sircreb/contribuyente/consultaPadronServlet?sistema=${p_sistema}&cuit=${p_cuit}&anio=${p_anio}&mes=${p_mes}`,
          apiURL +'?sistema='+p_sistema+'&cuit='+p_cuit+'&anio='+p_anio+'&mes='+p_mes,
          {  
            'Content-Type': 'application/json',
             //'mode': 'no-cors'                     
          },5
        );         
        result.then(response => {
          return response.arrayBuffer();
        }).then(buffer =>{           
            
            const decoder = new TextDecoder('iso-8859-1');
            const text = decoder.decode(buffer);
            const json = JSON.parse(text);            
            
            setResponse(json);
            setShowModal(true);
            setLoading(false);
            setErrorApi(false);
            
        }).catch(error =>{         
          setErrorApi(true);
          setLoading(false);
          setShowModal(false);
        })        
      } catch (err) {
        setErrorApi(true);
        setLoading(false);
        setShowModal(false);                
      }
    }
  };

  const handleCloseModal = () => setShowModal(false);

  const handleShowModal = () => setShowModal(true);

  return {
    form,
    errors,
    loading,
    response,
    showModal,
    errorAPI,
    handleChange,
    handleBlur,
    handleSubmit,
    handleCloseModal,
    handleShowModal,
  };
};
